import { Button, Menu, MenuItem, MenuList } from "@material-ui/core";
import { ViewComfy } from "@material-ui/icons";
import { memo, useState } from "react";
import { groupBy } from "../ContasReceberConstants";
import { useContasReceberService } from "../context/ContasReceberContext";
const GroupMenuButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { setGroupBy } = useContasReceberService();

  const [label, setLabel] = useState("Sem agrupamento");

  const handleOpenOptions = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectGroup = ({ groupOption, groupLabel }) => {
    setGroupBy(groupOption);
    setLabel(groupLabel);
    handleClose();
  };

  return (
    <>
      <Button
        size="small"
        startIcon={<ViewComfy />}
        color="primary"
        variant="outlined"
        onClick={handleOpenOptions}
      >
        {label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        onClose={handleClose}
        open={!!anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuList>
          {Object.entries(groupBy).map(([key, value]) => (
            <MenuItem
              value={value}
              key={value}
              onClick={() =>
                handleSelectGroup({
                  groupLabel: key,
                  groupOption: value,
                })
              }
            >
              {key}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </>
  );
};

export default memo(GroupMenuButton);
